var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporateTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 30.9,
    cy: 5.6,
    r: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9,19.3c-5-0.5-9.9-5.9-11.1-6.7c-0.7-0.5-1.6-0.9-2.5-1c0,0-0.6-0.1-1.2-0.1c-0.6,0.1-1.5,0.1-2.8,1.1c-0.1,0.1-0.8,0.7-1,0.9c-1.7,1.7-6.2,6.8-8.5,12.5c-0.3,0.8-0.1,1.7,0.4,2.3l-2.7,4.8L11.7,31c-0.5-0.3-1-0.1-1.3,0.4L3.3,43.9c-0.3,0.5-0.1,1,0.4,1.3l2.9,1.6c-0.5,0.8-0.3,1.9,0.3,2.6c0.8,0.8,2.2,0.9,3,0c0.8-0.8,0.8-2,0.2-2.8l3.9-6.8l2.7-4.9l3.4-5.9c0.7-0.1,1.4-0.6,1.7-1.3c1-2.4,2.5-4.8,3.9-6.7l0.7,7.8c0.1,0.9,0.5,1.7,1,2.3c-1.8,3.2-6.5,11.9-8.2,14.8c-0.8,1.3-0.3,3,1,3.8c0.5,0.3,1,0.4,1.6,0.4c0.9-0.1,1.7-0.6,2.2-1.4c1.6-2.8,5.7-11.1,7.5-14.2c1.5,2.4,3.9,6.9,7.1,14c0.5,1,1.5,1.6,2.5,1.6c0.4,0,0.8-0.1,1.1-0.2c1.4-0.6,2-2.3,1.4-3.7c-3.7-8.4-6.4-13-8-15.5c0.6-0.8,1-1.7,0.9-2.8L36,20.4c1.9,1.5,4.3,2.7,8.5,3.2c0.1,0,0.2,0,0.2,0c1.1,0,2-0.8,2.2-2C46.9,20.5,46.1,19.4,44.9,19.3z M8.3,48.7c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8C9.1,48.4,8.8,48.7,8.3,48.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateTravel);
export default __webpack_public_path__ + "static/media/corporate-travel.4a7f32eae8a861fe8d894750df13dd6f.svg";
export { ForwardRef as ReactComponent };